import { useCallback } from "react";

import { usePerson } from "@/shared/hooks/useAppContext";
import { useEstateItems } from "@/shared/hooks/useEstateItems";

import type { EstateItem } from "@/shared/types/estateTypes";

import { persistVehicleItems } from "../utils/formSubmitHelpers";

export function useSaveVehicleItems(
  isVehicleModule: boolean,
  vehicleItems: EstateItem[],
  addEstateItem: ReturnType<typeof useEstateItems>["addItem"],
  updateEstateItem: ReturnType<typeof useEstateItems>["updateItem"],
) {
  const person = usePerson();

  return useCallback(
    async (data: Record<string, string>) => {
      if (isVehicleModule && person?.estate_id) {
        await persistVehicleItems(
          data,
          vehicleItems,
          person.estate_id,
          addEstateItem,
          updateEstateItem,
        );
      }
    },
    [isVehicleModule, person?.estate_id, vehicleItems, addEstateItem, updateEstateItem],
  );
}
